import React, { useState, useEffect } from "react";
import { CaretRightOutlined } from "@ant-design/icons";
import { Col, Collapse, Row } from "antd";

// styling
import screenSize from "utils/screenSize";
import { StyledSectionButton, CollapsedSearchResult } from "./CourseListStyle";
import CourseClasses from "./CourseClasses";
import BookAll from "./BookAll";
import { ContentSection } from "./BookACourseStyle";

const { Panel } = Collapse;

type CourseListProps = {
  courseList: any[];
  loadingCourseList: boolean;
  courseFromLocationId: number | undefined;
  isHighestLevel: boolean;
  setCourseFromLocationId: (id: number) => void;
};

const CourseList = ({
  courseList,
  loadingCourseList,
  courseFromLocationId,
  isHighestLevel,
  setCourseFromLocationId,
}: CourseListProps) => {
  const [bookall, setBookAll] = useState(0);

  const refs = courseList?.reduce(
    (acc, course: { description: string; id: number }) => {
      acc[course.id] = React.createRef();
      return acc;
    },
    {}
  );

  useEffect(() => {
    if (courseFromLocationId && refs[courseFromLocationId]?.current) {
      const top = Number(refs[courseFromLocationId].current.offsetTop - 80);
      window.scrollTo(0, top);
    }
  }, [courseFromLocationId, refs]);

  const parsedCourseDescription = (courseDescription: string) => {
    const removedCourseName = courseDescription.split("/")[0];
    const removeSpecialCharactor = removedCourseName.replace(/[\][]/g, "");
    const removeCourseLevel = `${removeSpecialCharactor.split("·")[1]}-${
      removeSpecialCharactor.split("·")[2]
    }-${removeSpecialCharactor.split("·")[3]}`;
    const startEndOnly = `${removeSpecialCharactor.split("·")[2]}-${
      removeSpecialCharactor.split("·")[3]
    }`;
    if (screenSize() !== "mobile") {
      return <span>{removeCourseLevel} </span>;
    }

    return (
      <span>
        <span> {removeSpecialCharactor.split("·")[1]} </span>
        <div style={{ paddingLeft: "35px" }}>{startEndOnly.trim()}</div>
      </span>
    );
  };
  const genPanelButtons = (id: number) => (
    <Row gutter={10}>
      <Col xs={12}>
        <StyledSectionButton className="show" type="primary">
          CLASSES
        </StyledSectionButton>
      </Col>
      <Col xs={12}>
        <StyledSectionButton
          type="primary"
          className="book-all"
          onClick={(e) => {
            e.stopPropagation();
            setBookAll(id);
          }}
        >
          BOOK ALL
        </StyledSectionButton>
      </Col>
    </Row>
  );
  if (loadingCourseList) return <p>Loading ....</p>;
  if (courseList.length === 0)
    return (
      <p>
        There are no Intensive Courses on weekends. Choose a Standard Course
        instead
      </p>
    );

  return (
    <ContentSection style={{ padding: "0 8%" }}>
      <CollapsedSearchResult
        bordered={false}
        defaultActiveKey={courseFromLocationId || undefined}
        expandIcon={() => <CaretRightOutlined />}
      >
        {courseList.map((course: { description: string; id: number }) => (
          <Panel
            header={parsedCourseDescription(course.description)}
            key={course.id}
            extra={genPanelButtons(course.id)}
          >
            <Row ref={refs[course.id]}>
              <CourseClasses
                currentCourseId={course.id}
                courseDescription={course.description.split("/")[1]}
                isHighestLevel={isHighestLevel}
                setCourseFromLocationId={setCourseFromLocationId}
              />
            </Row>
          </Panel>
        ))}
        {bookall && (
          <BookAll
            currentCourseId={bookall}
            isHighestLevel={isHighestLevel}
            setCourseFromLocationId={setCourseFromLocationId}
            setBookAll={setBookAll}
          />
        )}
      </CollapsedSearchResult>
    </ContentSection>
  );
};

export default CourseList;
